import { createContext } from 'react';
import { createMongoAbility, MongoAbility } from '@casl/ability';

export const PermissionsContext =
  createContext<MongoAbility>(createMongoAbility());
